import React, { useState } from 'react'
import AdminHeading from '../Heading/AdminHeading'
import ListTable from 'Components/CommonComponents/ListTable'
import { ClipLoader } from 'react-spinners'
import ErrorModal from 'Components/Other Functions/popup'
import AlertMessage from 'Components/Other Functions/AlertMessage'
import { useSelector } from 'react-redux'
import GetApiService from 'Components/Api/getapiService'
import { useQuery } from '@tanstack/react-query'
import { Link, useNavigate } from 'react-router-dom'
import { a188 } from 'Components/Api/RootApiPath'
import { Add } from '@mui/icons-material'

const AdminPurchaseEntriesList = () => {
    const [ loading,setLoading] = useState(false)
    const [ showModal,setShowModal] = useState(false)
    const [ errorMessage,setErrorMessage] = useState("")
    const [ showError,setShowError] = useState(false)
    const allStates = useSelector((state) => state);
    const navigate = useNavigate()
    const adminLoggedIn = allStates.reducer1;
    const clientCode = adminLoggedIn.ClientCode;
    const apiService = new GetApiService(clientCode);

    const fetchData = async () => {
        try {
          const data = await fetch(a188, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    ClientCode: clientCode,
                  }),
              })
          const result = await data?.json()      
                
          return result;
        } catch (e) {
          console.log(e);
        }
      };
    const {
        data:InvoiceList,
        isLoading,
        isError,
      } = useQuery({
        queryKey: ["getInvoiceList"],
        queryFn: fetchData,
        refetchOnWindowFocus: false,
        // cacheTime: 1000 * 60 * 2,
        // staleTime: 1000 * 60 * 2,
      }); 
     


    const handleEditData = (product)=>{
        navigate(`/edit_invoice_new/${product?.Id}`)
    }
    const columns = [
        {key:"Id",label:"Id"},
        {key:"InvoiceNo",label:"Invoice Number"},
        {key:"InvoiceDate",label:"Invoice Date"},
        {key:"InvoiceStatus",label:"Invoice Status"},
        {key:"FirstName",label:"Name"},
        {key:"CustomerId",label:"Customer Id"},
    ]
  return (
    <>
    
    <div>
      <AdminHeading />
      {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={()=>{}} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        )}
    </div>
    <div style={{padding:"5px 20px"}}>
     <div style={{display:'flex',justifyContent:'end'}}>
      
      <Link to={`/invoice_entry_new`} style={{textDecoration:"none",display:'flex',justifyContent:'center',alignItems:'center',gap:"4px",cursor:'pointer',color:"#fff",background:"#0077d4",borderRadius:'5px',padding:"4px 10px"}} >Add <Add/></Link>

    
     </div>
      <ListTable
      columns={columns}
      handleEditData={handleEditData}
      data={InvoiceList?.length ? [...InvoiceList].reverse( ) : []}
      />
      </div>
    </>
  )
}

export default AdminPurchaseEntriesList
